import React, { useContext, useRef, useState } from 'react'
import { Context } from "../../../index"
import Dropdown from '../Dropdown/Dropdowns'
import Field from '../Field/Field'
import NavbarSelected from '../Navbar/NavbarSelected/NavbarSelected'
import RadioButtons from '../RadioButtons/RadioButtons'
import { resetSearchProducts, searchProducts } from './SearchUtils'
import styles from './ShopDeviceList.module.scss'

const FilterSortPanel = ({
	isTabletScreen,
	setIsFilterVisible,
	cityRepresentation,
	setCityRepresentation,
	locations,
	setIsRefreshCatalog
}) => {
	const { device, search } = useContext(Context)
	const [isFilterDropdownVisible, setIsFilterDropdownVisible] = useState(true)
	const [isSortDropdownVisible, setIsSortDropdownVisible] = useState(false)
	const [minPriceFilter, setMinPriceFilter] = useState('')
	const [maxPriceFilter, setMaxPriceFilter] = useState('')
	const [oemNumber, setOemNumber] = useState('')
	const [isReset, setIsReset] = useState(false)


	const onSearch = (isMinPriceChanged = false, isMaxPriceChanged = false, minPrice = null, maxPrice = null, oemNumberValue = oemNumber) => {
		search.setPage(1)
		if (isMinPriceChanged) {
			search.setMinPriceFilter(minPrice)
		}
		if (isMaxPriceChanged) {
			search.setMaxPriceFilter(maxPrice)
		}

		search.setOemNumberFilter(oemNumberValue)

		searchProducts(search, device)

		setIsRefreshCatalog(true)
		setTimeout(() => {
			setIsRefreshCatalog(false)
		}, 1000)
	}

	const prevValueRef = useRef('')
	const handleChange = (e) => {
		const value = e.target.value.trim()
		const prevValue = prevValueRef.current.trim()

		setOemNumber(value)
		prevValueRef.current = value

		if (value.length > 0 || prevValue.length > 0) {
			onSearch(true, true, minPriceFilter, maxPriceFilter, value || null)
		}
	}


	return (
		<div className='flex flex-col gap-3'>
			<div className='flex flex-row justify-between gap-10'>
				<Field
					required={false}
					placeholder='Введите номер детали'
					className='bg-grey py-[13px] px-[35px] rounded-2xl w-full min-w-full cursor-pointer'
					type='text'
					name='oemNumber'
					value={oemNumber}
					onChange={handleChange}
					full='w-full'
				/>
			</div>
			<button
				className={`${styles.customButton} ${styles.lightAccent} ${styles.buttonWithArrow} rounded-xl relative flex justify-between w-full`}
				onClick={() => {
					if (isFilterDropdownVisible && !isSortDropdownVisible) {
						setIsFilterDropdownVisible(false)
						setIsSortDropdownVisible(false)
					} else {
						setIsFilterDropdownVisible(true)
						setIsSortDropdownVisible(false)
					}
				}}>
				<span>Фильтры</span>
				<svg
					className={`${styles.customArrow} ${isFilterDropdownVisible ? styles.rotateCustomArrow : ''
						} relative w-7 h-7 left-3`}
					viewBox='0 0 24 24'
					fill='none'
					style={{ bottom: '2px' }}
					xmlns='http://www.w3.org/2000/svg'
					transform='rotate(-225)'
					stroke='#ffffff'>
					<g id='SVGRepo_bgCarrier' strokeWidth='0' />
					<g id='SVGRepo_tracerCarrier' strokeLinecap='round' strokeLinejoin='round' />
					<g id='SVGRepo_iconCarrier'>
						{' '}
						<g clipPath='url(#clip0_429_11220)'>
							{' '}
							<path
								d='M16 16L16 8L8 8'
								strokeWidth='1.4'
								strokeLinecap='round'
								strokeLinejoin='round'
							/>{' '}
						</g>{' '}
						<defs>
							{' '}
							<clipPath id='clip0_429_11220'>
								{' '}
								<rect width='38' height='38' />{' '}
							</clipPath>{' '}
						</defs>{' '}
					</g>
				</svg>
			</button>
			<div className={`block ${isFilterDropdownVisible ? '' : 'hidden'}`}>
				<NavbarSelected />
			</div>
			<button
				className={`${styles.customButton} ${styles.lightAccent} ${styles.buttonWithArrow} rounded-xl relative flex justify-between w-full`}
				onClick={() => {
					if (isSortDropdownVisible && !isFilterDropdownVisible) {
						setIsFilterDropdownVisible(false)
						setIsSortDropdownVisible(false)
					} else {
						setIsFilterDropdownVisible(false)
						setIsSortDropdownVisible(true)
					}
				}}>
				<span>Сортировка</span>
				<svg
					className={`${styles.customArrow} ${isSortDropdownVisible ? styles.rotateCustomArrow : ''
						} relative w-7 h-7 left-3`}
					viewBox='0 0 24 24'
					fill='none'
					style={{ bottom: '2px' }}
					xmlns='http://www.w3.org/2000/svg'
					transform='rotate(-225)'
					stroke='#ffffff'>
					<g id='SVGRepo_bgCarrier' strokeWidth='0' />
					<g id='SVGRepo_tracerCarrier' strokeLinecap='round' strokeLinejoin='round' />
					<g id='SVGRepo_iconCarrier'>
						{' '}
						<g clipPath='url(#clip0_429_11220)'>
							{' '}
							<path
								d='M16 16L16 8L8 8'
								strokeWidth='1.4'
								strokeLinecap='round'
								strokeLinejoin='round'
							/>{' '}
						</g>{' '}
						<defs>
							{' '}
							<clipPath id='clip0_429_11220'>
								{' '}
								<rect width='38' height='38' />{' '}
							</clipPath>{' '}
						</defs>{' '}
					</g>
				</svg>
			</button>
			<div style={{
				height: isSortDropdownVisible ? "auto" : "0px",
				overflowY: isSortDropdownVisible ? 'initial' : 'hidden'
			}}>
				<div className='flex flex-col'>
					<div className='flex flex-col w-full'>
						<div className='flex gap-x-3'>
							<input
								className='flex p-3 bg-grey w-1/2 rounded-xl mt-3 items-center justify-between placeholder:text-dark outline-none'
								value={minPriceFilter}
								onChange={e => {
									if (Number(e.target.value) > -1 && e.target.value !== "0" && Number(e.target.value) < 1000000000) {
										setMinPriceFilter(e.target.value)
										onSearch(true, false, e.target.value)
									}
								}}
								placeholder='Цена от'
							/>
							<input
								className='flex p-3 bg-grey w-1/2 rounded-xl mt-3 items-center justify-between placeholder:text-dark outline-none'
								value={maxPriceFilter}
								onChange={e => {
									if (Number(e.target.value) > -1 && e.target.value !== "0" && Number(e.target.value) < 1000000000) {
										setMaxPriceFilter(e.target.value)
										onSearch(false, true, null, e.target.value)
									}
								}}
								placeholder='Цена до'
							/>
						</div>

						<Field
							required={true}
							placeholder='Город'
							className='flex p-3 bg-grey rounded-xl mt-3 w-full items-center justify-between placeholder:text-dark outline-none'
							type='city'
							clearField={() => {
								setCityRepresentation('')
								search.setCityFilter(null)
								onSearch()
							}}
							items={locations}
							value={cityRepresentation}
							onChange={e => {
								setCityRepresentation(e.target.value)
								search.setCityFilter(null)
							}}
							func={(city_id, city_repr) => {
								search.setCityFilter(city_id)
								setCityRepresentation(city_repr)
								onSearch()
								search.setPage(1)
							}}
							full='w-11/12'
						/>

						<RadioButtons
							items={device.conditions}
							isReset={isReset}
							setIsReset={setIsReset}
							onChangeCallback={(selectedValue) => {
								search.setConditionFilter(selectedValue)
								onSearch()
							}}
						/>

						<Dropdown
							key={`generationSortFilter-${search.keyCounter}`}
							items={device.sortings}
							name={'Порядок'}
							className='w-full'
							fullWidth={true}
							isPageShop={true}
							isSort={false}
							type={true}
							onChangeCallback={(sortFilter, descFilter) => {
								search.setSortFilter(sortFilter)
								search.setDescFilter(descFilter)
								onSearch()
							}}
						/>
					</div>
				</div>
			</div>
			<div className='flex gap-x-3 mt-6'>

				<button
					className={`w-full rounded-xl ${styles.lightAccent} ${styles.customButton}`}
					onClick={() => {
						resetSearchProducts(search, device)
						setCityRepresentation('')
						setIsReset(true)
						setMinPriceFilter('')
						setMaxPriceFilter('')
						setOemNumber('')
					}}>
					Очистить
				</button>
			</div>
		</div>
	)
}

export default FilterSortPanel
